import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { authService } from '../../../services/api';
import { useNotifications } from '../../../contexts/NotificationContext';
import styles from './ForgotPassword.module.css';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const { addNotification } = useNotifications();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!email.trim()) {
      addNotification('Veuillez entrer votre adresse email', 'error');
      return;
    }

    setIsLoading(true);

    try {
      const response = await authService.forgotPassword(email);

      if (response.success) {
        setIsSubmitted(true);
        addNotification('Email de réinitialisation envoyé !', 'success');
      } else {
        addNotification(response.message || 'Erreur lors de l\'envoi de l\'email', 'error');
      }
    } catch (error) {
      addNotification(
        error.response?.data?.message || 'Erreur lors de l\'envoi de l\'email',
        'error'
      );
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className={styles.forgotPassword}>
      <div className={styles.container}>
        <div className={styles.card}>
          <h2>Mot de passe oublié</h2>

          {isSubmitted ? (
            <div className={styles.successMessage}>
              <p>✅ Un email de réinitialisation a été envoyé à <strong>{email}</strong></p>
              <p>Veuillez vérifier votre boîte de réception et suivre les instructions.</p>
              <Link to="/login" className={styles.backLink}>
                Retour à la connexion
              </Link>
            </div>
          ) : (
            <>
              <p className={styles.description}>
                Entrez votre adresse email et nous vous enverrons un lien pour réinitialiser votre mot de passe.
              </p>

              <form onSubmit={handleSubmit} className={styles.form}>
                <div className={styles.formGroup}>
                  <label htmlFor="email">Adresse email</label>
                  <input
                    type="email"
                    id="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="votre@email.com"
                    required
                    disabled={isLoading}
                  />
                </div>

                <button
                  type="submit"
                  className={styles.submitButton}
                  disabled={isLoading}
                >
                  {isLoading ? 'Envoi en cours...' : 'Envoyer le lien de réinitialisation'}
                </button>
              </form>

              <div className={styles.footer}>
                <Link to="/login" className={styles.link}>
                  Retour à la connexion
                </Link>
                <span className={styles.separator}>|</span>
                <Link to="/register" className={styles.link}>
                  Créer un compte
                </Link>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;

